import React from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
} from "reactstrap";
import PropTypes from "prop-types";
import TermsOfService from "./TermsOfService.js";
import { postVerify } from "../../../App/Api/register/verify.js";
import {} from "@fortawesome/free-brands-svg-icons";
import $ from "jquery";

import "./style.css";

class TosModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      termsOfService: "",
      privacyPolicy: "",
    };
  }

  // changetoLogin() {
  //   this.props.toggle('signin');
  //   this.props.toggle('login');
  // }

  changeToVerificationEmail = () => {
    this.props.toggle("tosmodal");
    // this.props.toggle("verificationPhoneModal");
    let data = this.props.registerData;
    // console.log(data);
    let vm = this;
    postVerify(data).then(function (res) {
      console.log(res);
      data = Object.assign({}, data, {
        emailVerificationToken: res.emailVerificationToken,
      });
      vm.props.setRegisterData(data);
      // vm.props.toggle("verificationPhoneModal");
      vm.props.toggle("verificationCodeModal");
    });
  };

  componentDidMount() {
    console.log("AMIGHERE", this.props.registerData);

    const vm = this;
    $.ajax({
      method: "GET",
      dataType: "json",
      traditional: true,
      data: {},
      xhrFields: {
        withCredentials: true,
      },
      url: process.env.REACT_APP_API + "/settings/privacypolicy",
    }).then(function (res) {
      let finishedTXT = res.data.content.replace(/\n/g, "<br>");
      vm.setState({ privacyPolicy: finishedTXT });
    });
  }

  render() {
    const closeBtn = (
      <button className="close" onClick={() => this.props.toggle("tosmodal")}>
        &times;
      </button>
    );
    return (
      <div>
        <Modal
          className="tos-modal"
          isOpen={this.props.modalOpen}
          toggle={() => this.props.toggle("tosmodal")}>
          <ModalHeader
            toggle={this.toggle}
            close={closeBtn}
            style={{ background: "#3E3F9B", paddingLeft: "40px" }}>
            Terms Of Service & Privacy Policy
          </ModalHeader>
          <ModalBody style={{ maxHeight: 600, overflowY: "auto" }}>
            <Form>
              <FormGroup style={{ padding: 15 }} row>
                <TermsOfService />

                <div
                  dangerouslySetInnerHTML={{
                    __html: this.state.privacyPolicy,
                  }}></div>
              </FormGroup>
            </Form>
          </ModalBody>
          <ModalFooter style={{ padding: "0rem 3rem 0 2rem" }}>
            <Button
              className="loginbutton"
              onClick={this.changeToVerificationEmail}
              size="lg"
              block>
              I Accept
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

TosModal.propTypes = {
  modalOpen: PropTypes.bool,
  toggle: PropTypes.func,
};

export default TosModal;
